
export function dataURLtoFile(dataurl, filename){
        
    var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), 
    n = bstr.length, 
    u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {type:mime});
}

export function isNilOrEmpty(value){
    if(value === null || value === undefined || value === '') return true

    if(Array.isArray(value)) return value.length === 0

    if(typeof value === 'object') return Object.keys(value).length === 0

    return false
}

export function valueOrDefault(value, defaultValue){
    if(!isNilOrEmpty(value)) return value

    return typeof defaultValue === 'function' ? defaultValue() : defaultValue
}

export function getPlaceHierarchyLabelByRegion(region, regionsList2Level = [], townshipsList2Level = [], districtsList2Level = []){
    const regionValue = typeof region === 'object' && region !== null
        ? Number(region.value ?? region.id)
        : Number(region)

    if(regionValue == null || Number.isNaN(regionValue)){
        return region?.label ?? region ?? ''
    }

    const regionItem = regionsList2Level.find((item) => Number(item?.value) === regionValue)
    const townshipValue = Number(regionItem?.child?.value)
    const townshipItem = townshipsList2Level.find((item) => Number(item?.value) === townshipValue)
    const districtValue = Number(townshipItem?.child?.value)
    const districtItem = districtsList2Level.find((item) => Number(item?.value) === districtValue)
    const governorateItem = districtItem?.child

    const labels = [
        governorateItem?.label,
        districtItem?.label,
        townshipItem?.label,
        regionItem?.label,
    ].filter((label) => typeof label === 'string' && label.trim().length > 0)

    return labels.length > 0 ? labels.join(' - ') : (region?.label ?? region ?? '')
}

export function getEducationHierarchyLabelByDepartment(department, departmentsList2Level = [], collegesList2Level = []){
    const departmentValue = typeof department === 'object' && department !== null
        ? Number(department.value ?? department.id)
        : Number(department)

    if(departmentValue == null || Number.isNaN(departmentValue)){
        return department?.label ?? department ?? ''
    }

    const departmentItem = departmentsList2Level.find((item) => Number(item?.value) === departmentValue)
    const collegeValue = Number(departmentItem?.child?.value)
    const collegeItem = collegesList2Level.find((item) => Number(item?.value) === collegeValue)
    const universityItem = collegeItem?.child

    const labels = [
        universityItem?.label,
        collegeItem?.label,
        departmentItem?.label,
    ].filter((label) => typeof label === 'string' && label.trim().length > 0)

    return labels.length > 0 ? labels.join(' - ') : (department?.label ?? department ?? '')
}


export const formatTime12Hour = (dateTime) => {
  return new Date(dateTime).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const splitDateTime = (dateTime) => {
  const [date] = dateTime.split("T");
  return { date, time: formatTime12Hour(dateTime) };
};